import axios from "axios";

export function getEventList(co) {
  const config = {
    params: co,
  };
  return axios.get(process.env.VUE_APP_API_URL + "Events/getlist", config);
}

export function getEventById(eventId) {
  const config = {
    params: {
      id: eventId,
    },
  };
  return axios.get(process.env.VUE_APP_API_URL + "Events/getbylistid", config);
}

export function postEvent(data) {
  const config = {
    headers: { "Content-Type": "multipart/form-data" },
  };
  return axios.post(process.env.VUE_APP_API_URL + "Events/add", data, config);
}

export function updateEvent(data) {
  const config = {
    headers: { "Content-Type": "multipart/form-data" },
  };
  return axios.put(process.env.VUE_APP_API_URL + "Events/update", data, config);
}

export function deleteEvent(eventsId) {
  const config = {
    params: {
      eventsId: eventsId,
    },
  };

  return axios.delete(process.env.VUE_APP_API_URL + "Events/deleted", config);
}

//Event Uploads
export function getEventUploadByEventId(eventId) {
  const config = {
    params: {
      eventId: eventId,
    },
  };
  return axios.get(process.env.VUE_APP_API_URL + "EventUpload/getlist", config);
}

export function postEventUpload(data) {
  const config = {
    headers: { "Content-Type": "multipart/form-data" },
  };
  return axios.post(process.env.VUE_APP_API_URL + "EventUpload/add", data, config);
}

export function deleteEventUpload(eventUploadId) {
  const config = {
    params: {
      eventUploadId: eventUploadId,
    },
  };

  return axios.delete(process.env.VUE_APP_API_URL + "EventUpload/deleted", config);
}
